import { jsx, Themed } from 'theme-ui'
import { List, ListItem } from '../../elements/trustyle-list'
import Markdown from 'markdown-to-jsx'

const cs = (...c) => c.filter(i => i).join(' ')
const styles = {
  fontFamily: 'body',
}

const MarkdownList = ({ ordered, ...props }) => {
  return (
    <List listType={ordered ? 'numeric' : 'bullet'} {...props}>
      {props.children}
    </List>
  )
}

const MarkdownHeading = props => {
  const Heading = Themed[`h${props.level}`]
  return <Heading {...props}>{props.children}</Heading>
}

export const Copy = ({ copy, as = Themed.p, children, className, options = {}, ...props }) => (
  <Choose>
    <When condition={options.markdown}>
      <Markdown
        sx={styles}
        children={children || copy}
        className={cs(options.className, className)}
        overrides={{
          paragraph: { component: Themed.p },
          link: { component: Themed.a },
          list: { component: MarkdownList },
          listItem: { component: ListItem },
          heading: { component: MarkdownHeading },
        }}
      />
    </When>
    <Otherwise>
      {jsx(as, {
        className: cs(options.className, className),
        sx: styles,
        children: children || copy,
      })}
    </Otherwise>
  </Choose>
)

export default Copy
